<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7"> Detail zprávy </v-card-title>
        <v-card-text class="pa-7">
          <v-row class="pb-6">
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="py-0">
                  <div class="request-label">Obsah</div>
                  <div class="request-value mt-2">
                    {{ message.content }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="pb-6">
            <v-col cols="6">
              <v-row>
                <v-col cols="12" class="py-0">
                  <div class="request-label">Komu</div>
                  <div class="request-value mt-2">
                    {{ message.whom.text }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            style="color: #e53935"
            outlined
            depressed
            @click="removeMessage()"
          >
            Smazat
          </v-btn>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :to="{ name: 'messages.edit', params: { id: message.id } }"
          >
            Editovat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
    <MessageUsers :id="$route.params.id" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import MessageUsers from '../../../components/message/MessageUsers'

export default {
  name: 'MessageDetail',
  components: { MessageUsers },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      message: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadMessage()
  },
  methods: {
    ...mapActions({
      getMessage: 'message/getMessage',
      deleteMessage: 'message/deleteMessage',
    }),
    loadMessage() {
      this.loading = true
      this.getMessage(this.$route.params.id)
        .then((response) => {
          this.message = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    removeMessage() {
      this.$confirm('', {
        title: 'Smazat zprávu?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.loading = true
          this.deleteMessage(this.$route.params.id)
            .then(() => {
              this.$router.push({
                name: 'messages',
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
